import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth, homePathFor } from "@/context/AuthContext";
import { Menu, X, Phone } from "lucide-react";

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const links = [
    { label: "Home", to: "/" },
    { label: "Servizi", to: "/servizi" },
    { label: "Come funziona", to: "/#come-funziona" },
    { label: "Sicurezza", to: "/#sicurezza" },
    { label: "FAQ", to: "/#faq" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-[#D2E3DB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
               className="text-sm font-semibold text-[#5C6B68] hover:text-[#087A73] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Button data-testid="nav-area-riservata" onClick={() => navigate(homePathFor(user.role))}
              className="bg-[#087A73] hover:bg-[#06615B] text-white rounded-xl h-11 px-5 font-semibold">
              La mia area
            </Button>
          ) : (
            <>
              <Button data-testid="nav-login" variant="outline" onClick={() => navigate("/login")}
                className="rounded-xl h-11 px-5 border-2 border-[#087A73] text-[#087A73] hover:bg-[#087A73]/10 font-semibold">
                Accedi
              </Button>
              <Button data-testid="nav-richiedi" onClick={() => navigate("/login?role=patient")}
                className="bg-[#087A73] hover:bg-[#06615B] text-white rounded-xl h-11 px-5 font-semibold">
                Richiedi una visita
              </Button>
            </>
          )}
        </div>
        <button data-testid="nav-mobile-toggle" className="lg:hidden p-2 text-[#102A2A]" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#D2E3DB] bg-white px-4 py-4 space-y-2">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)}
               className="block py-2 text-base font-semibold text-[#5C6B68]">{l.label}</a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            {user ? (
              <Button onClick={() => navigate(homePathFor(user.role))} className="bg-[#087A73] text-white rounded-xl h-12">La mia area</Button>
            ) : (
              <>
                <Button variant="outline" onClick={() => navigate("/login")} className="rounded-xl h-12 border-2 border-[#087A73] text-[#087A73]">Accedi</Button>
                <Button onClick={() => navigate("/login?role=patient")} className="bg-[#087A73] text-white rounded-xl h-12">Richiedi una visita</Button>
              </>
            )}
          </div>
          <div className="pt-2 flex items-center gap-2 text-sm text-[#5C6B68]"><Phone className="h-4 w-4" /> Assistenza Arezzo: 388 245 4770</div>
        </div>
      )}
    </header>
  );
}
